import React from "react";
import { render } from "react-dom";
import VerifiedEmailPopUp from "./VerifiedEmailPopUp";

export function init(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>) {
   render(
         <VerifiedEmailPopUp venueId={model.VenueId} />,
      document.body.appendChild(document.createElement("div"))
   );
}
